export * from "components/AdvisedCriticalHistory/components/AdvisedCriticalHistoryTable/hooks/useAdvisedCriticalHistory";
